import { render, staticRenderFns } from "./QuickbarButton.vue?vue&type=template&id=7156fae4&scoped=true"
import script from "./QuickbarButton.vue?vue&type=script&lang=js"
export * from "./QuickbarButton.vue?vue&type=script&lang=js"
import style0 from "./QuickbarButton.vue?vue&type=style&index=0&id=7156fae4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7156fae4",
  null
  
)

export default component.exports